<template>
  <div class="project__item">
    <div class="project__video" v-if="showVideo">
      <video-player
        v-if="showVideo"
        :options="videoOptions"
        @close-video="removeVideoPlayer"
      />
    </div>
    <h2 class="project__title">
      {{ first_line }} <br />
      {{ second_line }}
    </h2>
    <div class="project__image" @click="playVideo">
      <img
        class="project__img"
        :src="require(`@/assets/${image}`)"
        :alt="name"
      />
      <button class="project__button" @click="playVideo">
        <div class="project__svg--mobile">
          <svg
            fill="none"
            height="41"
            viewBox="0 0 47 51"
            width="47"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m10.2567 10.3312v30.3376l26.4871-15.5102z"
              fill="#fff"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="18.8976"
            />
          </svg>
        </div>
        <div class="project__svg--desktop">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="133"
            height="148"
            fill="none"
          >
            <path
              fill="#fff"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="18.898"
              d="M18.896 19.244v109.512l95.21-55.988-95.21-53.524Z"
            />
          </svg>
        </div>
      </button>
    </div>
    <div class="project__content">
      <FoldOut :description="description" :label="label" :slug="slug" />
    </div>
  </div>
</template>

<script>
import FoldOut from "@/components/FoldOut.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
  name: "ProjectItem",
  components: {
    FoldOut,
    VideoPlayer,
  },
  props: {
    name: String,
    first_line: String,
    second_line: String,
    description: String,
    label: String,
    image: String,
    videoOptions: Object,
    slug: String,
  },
  data() {
    return {
      showVideo: false,
    };
  },
  methods: {
    playVideo() {
      if (this.videoOptions) {
        this.showVideo = true;
      }
    },
    removeVideoPlayer() {
      this.showVideo = false;
    },
  },
};
</script>

<style scoped>
.project__item {
  margin-top: -20px;
}

.project__title {
  transform: translateY(calc(50% + 5px));
  z-index: 1;
  position: relative;
  padding-left: 10px;

  font-family: "Saira Condensed Bold", sans-serif;
  font-weight: 700;
  font-size: 100px;
  line-height: 80px;
  color: var(--color-yellow);
  text-transform: uppercase;
}

.project__video {
  max-width: 100%;
}

.project__close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background-color: var(--color-yellow);
  z-index: 1;
  border-radius: 50%;
  width: 88px;
  height: 88px;
  transition: transform 0.3s ease-in-out;

  svg {
    width: 37px;
  }
}

.project__image {
  max-width: 100%;
  position: relative;
}

.project__img {
  width: 100%;
}

.project__button {
  position: absolute;
  left: 11px;
  bottom: 19px;
  border: none;
  background-color: var(--color-yellow);
  z-index: 1;
  border-radius: 50%;
  width: 88px;
  height: 88px;
  transition: transform 0.3s ease-in-out;
  outline: none;
  cursor: pointer;

  svg {
    width: 37px;
  }
}

@media only screen and (min-width: 768px) {
  .project__button {
    width: 200px;
    height: 200px;
    left: 35px;
    bottom: 35px;

    svg {
      width: 133px;
      margin-left: 20px;
    }
  }
}

.project__button:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease-in-out;
}

.project__content {
}

@media only screen and (max-width: 768px) {
  .project__svg--mobile {
    display: block;
  }

  .project__svg--desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .project__svg--mobile {
    display: none;
  }

  .project__svg--desktop {
    display: block;
  }
}
</style>
